import { StepsProvider } from "react-step-builder";
import SecondMultiStepForm from "../components/CostumerMultiStepsForm/SecondMultiStepsForm";

const SecondVersion = ({ pathName }) => (
  <StepsProvider>
    <SecondMultiStepForm pathName={pathName} />
  </StepsProvider>
);

export default SecondVersion;